// import React from 'react'; // Removed as not used
import { Routes, Route, Navigate } from 'react-router-dom';
// 导入LoginScreen组件并指定其类型为React.ComponentType
import LoginScreen from '../screens/auth/LoginScreen';
import RegisterScreen from '../screens/auth/RegisterScreen';
import ForgotPasswordScreen from '../screens/auth/ForgotPasswordScreen';
import WelcomeScreen from '../screens/auth/WelcomeScreen';
import TermsOfServiceScreen from '../screens/legal/TermsOfServiceScreen';
import PrivacyPolicyScreen from '../screens/legal/PrivacyPolicyScreen';
import BlogScreen from '../screens/blog/BlogScreen';
import WhatIsZiweiScreen from '../screens/blog/WhatIsZiweiScreen';
import AstrologyGlossaryScreen from '../screens/blog/AstrologyGlossaryScreen';
import FeaturesScreen from '../screens/FeaturesScreen';

const AuthNavigator = () => {
  return (
    <Routes>
      <Route path="/" element={<WelcomeScreen />} />
      <Route path="/auth/welcome" element={<WelcomeScreen />} />
      <Route path="/auth/login" element={<LoginScreen />} />
      <Route path="/auth/register" element={<RegisterScreen />} />
      <Route path="/auth/forgot-password" element={<ForgotPasswordScreen />} />
      <Route path="/legal/terms-of-service" element={<TermsOfServiceScreen />} />
      <Route path="/legal/privacy-policy" element={<PrivacyPolicyScreen />} />
      <Route path="/blog" element={<BlogScreen />} />
        <Route path="/blog/what-is-ziwei-doushu" element={<WhatIsZiweiScreen />} />
        <Route path="/blog/astrology-glossary" element={<AstrologyGlossaryScreen />} />
        <Route path="/features" element={<FeaturesScreen />} />
      {/* 处理登出时可能停留在主应用路由的情况 */}
      <Route path="*" element={<Navigate to="/auth/welcome" replace />} />
    </Routes>
  );
};

export default AuthNavigator;